import { Component, Input, OnInit } from '@angular/core';
import { INotificationService } from '../../services/inotification.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-notification',
    imports: [TranslateModule],
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  text: string;
  description: string;
  position: {};

  constructor(private notificationService: INotificationService) { }

  ngOnInit() {
    this.text = this.notificationService.text;
    this.description = this.notificationService.description;
    this.position = this.notificationService.position;
  }

}
